import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import AlertBox from "../../AlertBox";
import { RequiredAsterisk } from "../../FormHelper";
import { updateFramedPoolById } from "../../../api/infrastructure";
import { useFramedPoolByIdHooks } from "../../../utils/infrastructure/FramedPoolUtils";

export default function ModalUpdateFramedPool({ id, show, onClose, onSuccess }) {
  return (
    <Modal show={show} onHide={() => onClose()}>
      <FormUpdateFramedPool id={id} onSuccess={onSuccess} onClose={() => onClose()} />
    </Modal>
  );
}

function FormUpdateFramedPool({ id, onSuccess, onClose }) {
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const { data, fetched, error } = useFramedPoolByIdHooks({ id });

  useEffect(() => {
    if (fetched) {
      setForm((prev) => ({
        ...prev,
        name: data.name || "",
      }));
    }
  }, [data, fetched]);

  const [form, setForm] = useState({ name: "" });

  const submitData = (event) => {
    event.preventDefault();
    sendUpdateFramedPool();
  };

  const sendUpdateFramedPool = async () => {
    setLoading(true);
    try {
      const { data } = await updateFramedPoolById(id, form);
      onSuccess(data.message);
      onClose();
    } catch (error) {
      let message = error.response?.data?.message || "Something Error Happened";
      setAlert({ show: true, message, type: "danger" });
    }
    setLoading(false);
  };

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>Update Framed Pool</Modal.Title>
      </Modal.Header>
      <form onSubmit={submitData}>
        <Modal.Body>
          {error && <div className="alert alert-danger">{error}</div>}
          <AlertBox {...alert} setAlert={setAlert} />
          <div className="form-group">
            <label>
              Name <RequiredAsterisk />{" "}
            </label>
            <input
              type="text"
              className="form-control"
              required
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
          <button type="submit" disabled={loading} className="btn btn-primary">
            {loading ? "Updating..." : "Update Framed Pool"}
          </button>
        </Modal.Footer>
      </form>
    </>
  );
}
